import { useContext } from 'react'

import { VacatureContext } from 'templates/vacature'

const useVacature = () => {
  const context = useContext(VacatureContext)

  return context
}

export default useVacature
